export const SET_AUTH_TOKEN = "SET_AUTH_TOKEN";
export const SET_APP_LANGUAGE = "SET_APP_LANGUAGE";
export const SET_LOGIN_DETAILS = "SET_LOGIN_DETAILS";
export const SET_USER_PROFILE = "SET_USER_PROFILE";
export const SET_PROFILE_IMAGE = "SET_PROFILE_IMAGE";
export const SET_SERVICE_LOADER = "SET_SERVICE_LOADER";
export const SET_ERROR_MESSAGE = "SET_ERROR_MESSAGE";
export const SET_AUTH_REFRESH_TOKEN = "SET_AUTH_REFRESH_TOKEN";
export const SET_PROFILE_CHOOSEN = "SET_PROFILE_CHOOSEN";
export const SET_ACCOUNT_LIST = "SET_ACCOUNT_LIST";
export const SET_LOAN_LIST = "SET_LOAN_LIST";
export const SET_DEPOSIT_LIST = "SET_DEPOSIT_LIST";
export const SET_LOGIN_VERIFY_DETAILS = "SET_LOGIN_VERIFY_DETAILS";
export const SET_TXN_PENDING_COUNT = "SET_TXN_PENDING_COUNT";
export const SET_ERROR_MESSAGE_MODAL = "SET_ERROR_MESSAGE_MODAL";
export const SET_DEVICE_ID = "SET_DEVICE_ID";
export const SET_SHARED_KEY = "SET_SHARED_KEY";
export const SET_SERVER_KEY = "SET_SERVER_KEY";
export const SET_MENU_OPEN = "SET_MENU_OPEN";
export const SET_ACCESS_LIST = "SET_ACCESS_LIST";
export const SET_ROLE_PERMISSION = "SET_ROLE_PERMISSION";
export const SET_SELECTED_ACCOUNT = "SET_SELECTED_ACCOUNT";
export const SET_TRANSACTION_CURRENCY_LIST = "SET_TRANSACTION_CURRENCY_LIST";
export const SET_CURRENT_ACC_DETAILS = "SET_CURRENT_ACC_DETAILS";
export const SET_DEFAULT_PATH = "SET_DEFAULT_PATH";
export const SET_LOGOUT = "SET_LOGOUT";
export const SET_QUICK_LINKS_DATA = "SET_QUICK_LINKS_DATA";
export const SET_OTP_TIMER = "SET_OTP_TIMER";
export const SET_SESSION_TIMER = "SET_SESSION_TIMER";
export const SET_QUICK_SEARCH = "SET_QUICK_SEARCH";
export const RESET_ALL_STATE = "RESET_ALL_STATE";
export const SET_COUNTRY_CODES = "SET_COUNTRY_CODES";






